export default {
    getDrawer({ drawer }){
        return drawer
    },

    getDrawerColor({ drawerColor }){
        return drawerColor
    },

    getAppBarColor({ appBarColor }){
        return appBarColor
    },

    getLoadingScreen({ loadingScreen }){
      return loadingScreen
    }
}
